const AboutBody = () => {
  return (
    <section className="page about section-spacing-20">
      <div className="container">
        <div className="large">
          <div className="section-content-container section-spacing-100 no-padding-top width-800 margin-auto">
            <ul className="page-sections-container">
              <li className="page-section-item border-blue-top">
                <h2 className="page-section-title ntuna-text-fill">Overview</h2>
                <p>
                  NTUNA.COM<sup>&trade;</sup> was founded in{" "}
                  <span className="ntuna-dark-coral">2017</span> and began as a
                  website design and digital marketing agency committed to
                  delivering international-standard digital services. As demand
                  for reliable technology solutions grew, we expanded our
                  expertise and evolved into a{" "}
                  <span className="ntuna-dark-coral">
                    full-service web and ICT solutions provider.
                  </span>
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title ntuna-text-fill">
                  Who We Are
                </h2>
                <p>
                  NTUNA.COM<sup>&trade;</sup> is an international ICT solutions
                  company specializing in website, systems, and app development;
                  digital marketing; ICT consultancy and equipment supply; CCTV
                  installation, IT security and networking solutions.
                </p>
                <p>
                  We work with organizations across multiple industries,
                  delivering tailored technology solutions that address real
                  challenges and drive measurable results.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title ntuna-text-fill">
                  Our Journey
                </h2>
                <p>
                  NTUNA.COM<sup>&trade;</sup> began in 2017 as a website design
                  and digital marketing agency focused on delivering
                  international-standard digital services.
                </p>
                <p>
                  As client demand grew, we expanded into a full-service ICT
                  solutions company — offering website, systems and app design
                  and development, digital marketing, ICT consultancy and
                  equipment supply, CCTV Installation and IT security, and
                  Networking. services.
                </p>
                <p>
                  Today, we are proud to have over 500 projects satisfactorily
                  done serving clients across Uganda, the United States, and
                  globally, delivering solutions that meet modern business
                  needs.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title ntuna-text-fill">
                  What We Do
                </h2>
                <p>
                  We help businesses, schools, Non-government organizations,
                  companies and institutions operate more efficiently through
                  reliable systems, professional support, and innovative
                  solutions tailored to their needs. By focusing on efficiency,
                  security, and sustainable growth, we ensure that our clients
                  thrive in an increasingly connected world.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title ntuna-text-fill">
                  Our Mission
                </h2>
                <p>
                  Our mission is to deliver reliable, innovative, and
                  high-performance ICT solutions that empower organizations to
                  grow and succeed in a digital world.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title ntuna-text-fill">
                  Our Vision
                </h2>
                <p>
                  To be a globally recognized ICT solutions provider known for
                  excellence, innovation, and long-term client partnerships.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title ntuna-text-fill">
                  Our Values
                </h2>
                <p>
                  <span className="ntuna-text-fill">1. Innovation: </span> We
                  continually adopt modern technologies to deliver future-ready
                  solutions.
                </p>
                <p>
                  <span className="ntuna-text-fill">2. Integrity: </span> We
                  operate with honesty, transparency, and reliability in every
                  project.
                </p>
                <p>
                  <span className="ntuna-text-fill">3. Excellence: </span> We
                  deliver high-quality ICT solutions backed by professional
                  standards and strong customer support.
                </p>
                <p>
                  <span className="ntuna-text-fill">4. Customer Focus: </span>{" "}
                  We listen, understand, and prioritize our clients’ needs,
                  ensuring solutions that fit their goals.
                </p>
                <p>
                  <span className="ntuna-text-fill">
                    5. Security and Trust:{" "}
                  </span>{" "}
                  We protect client data and systems with safe, secure, and
                  dependable technologies.
                </p>
                <p>
                  <span className="ntuna-text-fill">6. Professionalism: </span>{" "}
                  We uphold strong work ethics, timely delivery, and disciplined
                  project execution.
                </p>
                <p>
                  <span className="ntuna-text-fill">7. Collaboration: </span> We
                  build lasting relationships with clients, partners, and
                  communities through teamwork and shared growth.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title ntuna-text-fill">
                  Our Solutions
                </h2>
                <p>
                  We provide a comprehensive range of ICT solutions designed to
                  support businesses and organizations at every stage of growth.
                </p>
                <ul className="long-list">
                  <li>
                    <span>
                      <span>Website Design and Development</span>
                    </span>
                  </li>
                  <li>
                    <span>Custom Systems Development</span>
                  </li>
                  <li>
                    <span>Mobile Apps Development</span>
                  </li>
                  <li>
                    <span>Business Software Solutions</span>
                  </li>
                  <li>
                    <span>E-commerce Platforms</span>
                  </li>
                  <li>
                    <span>Digital Marketing Strategies</span>
                  </li>
                  <li>
                    <span>Logo Design & Brand Identity</span>
                  </li>
                  <li>
                    <span>Search Engine Optimization (SEO)</span>
                  </li>
                  <li>
                    <span>Social media setup & management</span>
                  </li>
                  <li>
                    <span>Social Media Ads Setup</span>
                  </li>
                  <li>
                    <span>ICT Consultancy, Training & Capacity Building</span>
                  </li>
                  <li>
                    <span>ICT Equipment Supply & Software Installation</span>
                  </li>
                  <li>
                    <span>CCTV Installation & IT Security Systems</span>
                  </li>
                  <li>
                    <span>Computer Lab & Office ICT Setup</span>
                  </li>
                  <li>
                    <span>Networking & IT Infrastructure Deployment</span>
                  </li>
                </ul>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title ntuna-text-fill">
                  Why Choose Us
                </h2>
                <p>
                  Organizations choose NTUNA.COM for our experience across
                  multiple industries, strong technical expertise, international
                  solutions delivery and a client-focused approach to delivering
                  reliable technology solutions.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title ntuna-text-fill">
                  Our Global Presence
                </h2>
                <p>
                  We serve clients across multiple regions, delivering ICT
                  solutions that meet international standards. We are physically
                  located in Kampala, Uganda; New York, USA; and Pretoria, South
                  Africa.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title ntuna-text-fill">
                  Technology Partnerships
                </h2>
                <p>
                  We collaborate with industry-leading technology companies to
                  deliver reliable, secure, and high-performance ICT solutions.
                  Our partners include Microsoft, Cisco, Google, Intel, Dell,
                  HP, Lenovo, Amazon, Meta, MTN and Airtel.
                </p>
              </li>
              <li className="page-section-item">
                <h2 className="page-section-title ntuna-text-fill">
                  Our Impact
                </h2>
                <ul>
                  <li>
                    <span>
                      <span>500+ projects delivered</span>
                    </span>
                  </li>
                  <li>
                    <span>
                      <span>10+ years experience</span>
                    </span>
                  </li>
                  <li>
                    <span>
                      <span>Clients in every continent</span>
                    </span>
                  </li>
                  <li>
                    <span>
                      <span>15+ industries served</span>
                    </span>
                  </li>
                </ul>
              </li>
              <li className="page-section-item center">
                <h2 className="page-section-title ntuna-text-fill">
                  Let’s Do Something Great For You
                </h2>
                <p>
                  Discuss your web, digital, and ICT needs with our team of
                  experts. Whatsapp or give us a call on{" "}
                  <a href="tel:+256702096666">+256-702-096-666</a>,{" "}
                  <a href="tel:+13153470333">+1-315-347-0333</a> and{" "}
                  <a href="tel:+256771001999">+256-771-001-999</a> or send us an
                  email to <a href="mailto:info@ntuna.com">info@ntuna.com.</a>
                </p>
                <div className="width-300 margin-auto">
                  {" "}
                  <a
                    href="https://form.jotform.com/ntuna/get-free-quote"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="maincta button boldTitle"
                  >
                    <span>Request Free Quote</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutBody;
